import React from 'react';

import AiAgentIcon from '@atlaskit/icon/core/ai-agent';
import IconTile from '@atlaskit/icon/icon-tile';

import { AGENT_AVATAR_CLIP_PATH } from './AgentAvatarFrame.tsx';

// Keep this Canvas shared fallback tile in sync with the local ExternalAgentAvatar in
// AgentPresenceAvatar.tsx. Page/editor intentionally keeps its local copy for now so this PR does
// not change the page presence runtime path before Team EU.
export const EXTERNAL_AGENT_AVATAR_COLOR = '#DDDEE1';

const styles = {
	display: 'inline-flex',
	// Match the hexagonal shape used by AgentAvatar in Studio.
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
	clipPath: AGENT_AVATAR_CLIP_PATH,
	// Match the neutral background used by the unidentified external-agent avatar in Analytics.
	// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/design-system/no-unsafe-design-token-usage
	['--ds-background-neutral' as const]: EXTERNAL_AGENT_AVATAR_COLOR,
} as React.CSSProperties;

export const ExternalAgentAvatar = ({ size }: { size: 'small' | 'medium' }): React.JSX.Element => (
	<span
		data-testid="external-agent-avatar"
		// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Uses clip-path and CSS custom property to match the shared agent avatar treatment.
		style={styles}
	>
		<IconTile icon={AiAgentIcon} label="" appearance="gray" size={size} />
	</span>
);
